export default "__VITE_ASSET__Cco7Wa0j__"